import apiAxios from 'helpers/apiAxios';

const BASE = '/monitoring/payment_plan_rates';

// Mirror of the server-side check; a call without it is rejected by the API.
export const CONFIRMATION_PHRASE = 'APPLY';

const message = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

export const fetchPaymentPlanRates = async () => {
  try {
    const res = await apiAxios.get(BASE);
    return res.data?.data || [];
  } catch (error) {
    throw new Error(message(error, 'Could not load payment plans to convert.'));
  }
};

export const applyPaymentPlanRates = async (scheduleIds) => {
  try {
    const res = await apiAxios.post(`${BASE}/apply`, {
      schedule_ids: scheduleIds,
      confirmation: CONFIRMATION_PHRASE,
    });
    return res.data?.data || {};
  } catch (error) {
    throw new Error(message(error, 'Could not apply exchange rates.'));
  }
};
